module.exports = __webpack_public_path__ + "static/media/leaf_embellishmentReverse.8d008725.svg";


//////////////////
// WEBPACK FOOTER
// ./src/leaf_embellishmentReverse.svg
// module id = 303
// module chunks = 0